import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import dayjs from 'dayjs'
import BaseService from 'services/BaseService'
import { popNotification } from 'utils/popNotification'
import { notificationConfig } from './constants'
import { LIMIT } from 'constants/app.constant'
import { formatDateSend } from '../../functions/formatDateSend'
import formatToDH from 'functions/dhformat'
const { creation, edit, deletion } = notificationConfig

// Redux Toolkit slice
const pagesWebsiteSlice = createSlice({
    name: 'pagesWebsite',
    initialState: {
        data: [],
        isLoading: false,
        error: null,
        created: null,
        isDeleted: null,
        currentPage: 1,
    },
    reducers: {

        resetDetailsPages: (state) => {
            if (state.detailsPages == null) {
                state.detailsPages = ''
            } else {
                state.detailsPages = null
            }
        },
        startLoading: state => {
            state.isLoading = true;
        },
        stopLoading: state => {
            state.isLoading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchPages.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchPages.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.data = action.payload
            })
            .addCase(fetchPages.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })


            .addCase(fetchDetailsSection.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchDetailsSection.fulfilled, (state, action) => {
                state.isLoading = false
                state.section = action.payload
            })
            .addCase(fetchDetailsSection.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })


            .addCase(fetchDetailsPages.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(fetchDetailsPages.fulfilled, (state, action) => {
                const currentPage = action?.meta?.arg?.page || state.currentPage;

                state.currentPage = currentPage
                state.isLoading = false
                state.detailsPages = action.payload
            })
            .addCase(fetchDetailsPages.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })

            .addCase(editPageText.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(editPageText.fulfilled, (state, action) => {
                state.isLoading = false
            })
            .addCase(editPageText.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })






            .addCase(setPixels.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(setPixels.fulfilled, (state, action) => {
                state.isLoading = false
            })
            .addCase(setPixels.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })


            .addCase(editContact.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(editContact.fulfilled, (state, action) => {
                state.isLoading = false
            })
            .addCase(editContact.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })

            .addCase(editSectionsSite.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(editSectionsSite.fulfilled, (state, action) => {
                state.isLoading = false
            })
            .addCase(editSectionsSite.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })

            .addCase(editConfig.pending, (state) => {
                state.isLoading = true
                state.error = null
            })
            .addCase(editConfig.fulfilled, (state, action) => {
                state.isLoading = false
            })
            .addCase(editConfig.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.error.message
            })





    },
})

// Async thunk action to fetch data from the API
export const fetchPages = createAsyncThunk(
    'pages/fetch',
    async (payload) => {

        try {
            const response = await BaseService.get(
                `/XML/website.pages.load`
            )

            return response.data
        } catch (error) {
            throw new Error('Failed to fetch pages')
        }
    }
)

export const fetchDetailsSection = createAsyncThunk(
    'section/fetch',
    async (payload) => {
        const { id } = payload

        try {
            const response = await BaseService.get(
                `/XML/website.pages.load/sectionsArticles?id=${id}`
            )
            return response.data
        } catch (error) {
            throw new Error('Failed to fetch pages')
        }
    }
)


// Async thunk action to fetch details from the API
export const fetchDetailsPages = createAsyncThunk(
    'Pages/fetchDetails',
    async (id) => {
        try {
            const Page = (await BaseService.get(
                `/XML/website.pages.load/details?id=${id}`,
            )).data

            return { page: Page.page }
        } catch (error) {
            throw new Error('Failed to fetch Pages')
        }
    }
)

export const editPageText = createAsyncThunk('pages/edit',
    async (payload) => {
        const { data, setPageUpdated } = payload
        try {
            const response = await BaseService.post('/XML/website.pages.send/editText', data)
            if (response.status === 200) {
                popNotification(creation?.success)
                setPageUpdated(true)
            }
        } catch (err) {
            console.log({ err })
            popNotification(creation?.error)
        }
    }
)


export const setPixels = createAsyncThunk('pages/pixels',
    async (payload) => {
        const { data, setPageUpdated } = payload
        try {
            const response = await BaseService.post('/XML/website.pages.send/pixels', data)
            if (response.status === 200) {
                popNotification(creation?.success)
                setPageUpdated(true)
            }
        } catch (err) {
            console.log({ err })
            popNotification(creation?.error)
        }
    }
)






export const editContact = createAsyncThunk('pages/editContact',
    async (payload) => {
        const { data, setPageUpdated } = payload
        try {
            const response = await BaseService.post('/XML/website.pages.send/editContact', data)
            if (response.status === 200) {
                popNotification(creation?.success)
                setPageUpdated(true)
            }
        } catch (err) {
            console.log({ err })
            popNotification(creation?.error)
        }
    }
)


export const editConfig = createAsyncThunk('pages/editConfig',
    async (payload) => {
        const { data, setPageUpdated } = payload
        try {
            const response = await BaseService.post('/XML/website.config.send/edit', data)
            if (response.status === 200) {
                popNotification(creation?.success)
                setPageUpdated(true)
            }
        } catch (err) {
            console.log({ err })
            popNotification(creation?.error)
        }
    }
)


export const editSectionsSite = createAsyncThunk('pages/editSectionsSite',

    async (payload) => {
        const { data, formik, navigate } = payload
        const { resetForm, setSubmitting } = formik
        try {
            const response = await BaseService.post('/XML/website.pages.send/sectionsArticles', data)
            if (response.status === 200) {
                resetForm()
                setSubmitting(false)
                popNotification(creation?.success)
                navigate(-1)
            }
        } catch (err) {
            console.log({ err })

            setSubmitting(false)

            popNotification(creation?.error)
        }
    }
)



export const selectData = (state) => state.pagesWebsite.data
export const selectIsLoading = (state) => state.pagesWebsite.isLoading
export const selectError = (state) => state.pagesWebsite.error
export const selectIsDeleted = (state) => state.pagesWebsite.isDeleted
export const selectCurrentPage = (state) => state.pagesWebsite.currentPage
export const { resetDetailsPages, startLoading, stopLoading } = pagesWebsiteSlice.actions
export default pagesWebsiteSlice.reducer